import React, { FC } from "react";
import cn from "classnames";
import { Button } from "@skyportal/ui-kit";
import { DateButtonsProps } from "./types";

import styles from "./DateButtons.module.css";

const DateButtons: FC<DateButtonsProps> = ({ dates, selected, onBtnClick }) => {
  return (
    <div className={styles.container}>
      {dates.map((date) => {
        const isSelected = date.value === selected;

        return (
          <Button
            key={date.value}
            htmlType="button"
            type="primary"
            primaryTypeColor={isSelected ? "grey10" : "lightGrey"}
            className={cn(styles.button, {
              [styles.selected]: isSelected,
            })}
            onClick={() => onBtnClick(date.value)}
          >
            {date.label}
          </Button>
        );
      })}
    </div>
  );
};

export default DateButtons;
